import { defineMessages } from "react-intl";

const messages = defineMessages({
  date: {
    id: "riskManagement.components.summary.date",
    defaultMessage: "Date",
  },
  slice: {
    id: "riskManagement.components.summary.slice",
    defaultMessage: "Slice",
  },
  req: {
    id: "riskManagement.components.summary.req",
    defaultMessage: "Requirement",
  },
  reqChg: {
    id: "riskManagement.components.summary.req.change",
    defaultMessage: "Change from SOD",
  },
  excess: {
    id: "riskManagement.components.summary.excess",
    defaultMessage: "Excess",
  },
});

export default messages;
